<template>
    <div class="website mt15" v-loading="isLoading">
<!--        <h3>-->
<!--          &lt;!&ndash;<a target="_blank" href="#">网站收录</a>&ndash;&gt;-->
<!--          <b>更多分类</b>-->
<!--        </h3>-->

<!--		<el-tabs @tab-click="loadSuperType">-->
<!--			<el-tab-pane v-for="(st, id) in superTypes" :label="st" :key="id"></el-tab-pane>-->
<!--		</el-tabs>-->
        <ul class="tab">
            <li>
                <div class="" @click="collect()">
                    <i class="fa fa-star" style="color: rgb(44 152 206);font-size: 16px;"></i>
                    收藏
                </div>
            </li>

            <li v-for="st in superTypes" :key="st.id" @click="loadSuperType(st.id)">
                <div :class="{'on': currentSuperType === st.id}">
                    <a>{{st.name}}</a>
                </div>
            </li>
            <!-- <li>
                <i class="el-icon-s-tools" @click="showSortingSuperType()" style="font-size: 18px; color: #14aab9;line-height: 30px;"></i>
               <i class="el-icon-s-tools" @click="settingDialogVisible=true" style="font-size: 15px; color: #14aab9; padding-left: 10px"></i>
            </li> -->
        </ul>
        <ul class="gray">
            <li class="tooltip" v-for="(type) in types" :key="type.id">
                <div @click="handleClick(type)">
                    <a>{{type.name}}</a>
                </div>
            </li>
        </ul>

        <!-- <li v-for="site in finalSites[type.id].slice(0,7)" :key="site.id"></li> -->
        <!-- <a :href="site.url" target="_blank" rel="nofollow">
                            SiteIcon style="margin: 8px 5px; width: 13px; height: 13px;" :url="site.url"/>
                            {{site.name}}
                        </a> -->
        <!-- <span class="last-span"><a @click="showMore(type)">更多</a></span> -->
		<!-- <el-dialog
		:title="moreDialogTitle"
		:visible.sync="moreDialogVisible"
		width="1060px" class="more-site-dialog">
			<ul class="more-dialog">
				<li v-for="site in moreDialogSites" v-show="site.tag === null" :key="site.id" style="position: relative">
					<el-tooltip class="item" popper-class="site-tooltip" effect="dark" placement="bottom" content="添加到常用网址" :enterable="false">
						<el-button type="text" size="mini" @click="addToCommon(site)"><img src="../assets/plus.png" width="18px"></el-button>
					</el-tooltip>
					<el-tooltip class="item" popper-class="site-tooltip" effect="dark" placement="bottom" :enterable="false">
						<div slot="content" style="max-width:300px;">
							{{site.name}}
							{{site.desc}}
						</div>
						<a :href="site.url" target="_blank" rel="nofollow" style="position: absolute; top: 2px; padding-left: 4px;">{{site.name}}</a>
					</el-tooltip>
				</li>
			</ul>
        <div v-for="tag in moreDialogTags">
            <el-divider><span style="    font-weight: bolder; color: #0070c0; margin-left: 10px; font-size: 17px;">{{tag}}</span></el-divider>

            <ul class="more-dialog">
                <li v-for="site in tagSiteMap[tag]" :key="site.id" style="position: relative">
                    <el-tooltip class="item" popper-class="site-tooltip" effect="dark" placement="bottom" content="添加到常用网址" :enterable="false">
                        <el-button type="text" size="mini" @click="addToCommon(site)"><img src="../assets/plus.png" width="18px"></el-button>
                    </el-tooltip>
                    <el-tooltip class="item" popper-class="site-tooltip" effect="dark" placement="bottom" :enterable="false">
                        <div slot="content" style="max-width:300px;">
                            {{site.name}}
                            {{site.desc}}
                        </div>
                        <a :href="site.url" target="_blank" rel="nofollow" style="position: absolute; top: 2px; padding-left: 4px;">{{site.name}}</a>
                    </el-tooltip>
                </li>
            </ul>
        </div>

		</el-dialog> -->

     <!-- <el-dialog
            title="分类管理"
            :visible.sync="sortingSuperTypeVisible"
            :before-close="closeSortingSuperType"
            width="50%"
            :close-on-click-modal="false">
            <el-divider content-position="left">拖动可对栏目排序，点击可管理其中的二级分类</el-divider>
            <draggable v-model="sortingSuperTypes" class="type-container">
                <div
                    class="type-item"
                    v-for="st in sortingSuperTypes"
                    :key="st.id" v-if="st.id!==undefined">
                    <el-tag @click="showSettingSubType(st.id)">
                        <span>{{st.value}}</span>
                    </el-tag>
                </div>
            </draggable>
            <el-divider></el-divider>
            <span></span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="sortingSuperTypeVisible=false">返 回</el-button>
                <el-button type="primary" @click="handleSuperTypeSave">保 存</el-button>
            </span>
        </el-dialog> -->

        <!-- 分类管理 -->
        <ManageType
            v-on:close-all="closeSortingSuperType"
		:typeList="manageSubTypes"
		:visible="settingDialogVisible"
		@close="settingDialogVisible=false"
		@save="saveSortedTypes"></ManageType>
        <!-- 三级菜单 -->
        <ManageCommon
            v-on:close-all="handleCloseAll"
            :visible="manageVisible"
            :manageType="manageType"
            :defaultSites="manageType.defaultSites"
                :customSites="manageType.customSites"
            @close="manageVisible=false"
            @save="onManageSave"></ManageCommon>
        <el-dialog custom-class="Mdivider" title="收藏" :visible.sync="dialogTableVisible" class="more-site-dialog">
            <el-divider></el-divider>
            <ul class="more-dialog" v-loading="isLoading1" >
                <li v-for="site in collectionData" :key="site.id" style="position: relative">
                    <el-tooltip class="item" popper-class="site-tooltip" effect="dark" placement="bottom" content="删除收藏" :enterable="false">
                        <el-button type="text" size="mini" @click="deleteCollect(site)">
                            <img src="../assets/deleteCollect.png" width="18px">
                        </el-button>
                    </el-tooltip>
                    <el-tooltip class="item" popper-class="site-tooltip" effect="dark" placement="bottom" :enterable="false">
                        <div slot="content" style="max-width:300px;">
                            {{site.name}}
                            {{site.description}}
                        </div>
                        <a :href="site.url" target="_blank" rel="nofollow" style="position: absolute; top: 2px; padding-left: 4px;">{{site.name}}</a>
                        <!-- <a :href="site.url" target="_blank" rel="nofollow" style="">{{site.name}}</a> -->
                    </el-tooltip>
                </li>
            </ul>
        </el-dialog>
	</div>
</template>

<script>
import ManageCommon from './ManageCommon.vue'
import draggable from 'vuedraggable'

import request from '@/utils/request'
import cs from "../utils/customSite";
import ManageType from './ManageType.vue';
import SiteIcon from "./SiteIcon";
import {eventBus} from "../main";

export default {
    components: {SiteIcon, draggable,ManageCommon ,ManageType},
    created() {
        this.loadSuperType()
        this.$nextTick(() => {
            this.init();
        })
    },
    data() {
        return {
        // 控制懒加载，未完成时显示加载样式，true未显示，false为隐藏
        isLoading: true,
        // 收藏中的控制懒加载
        isLoading1:true,
            stDict: null,
        // 一级菜单数据
        superTypes: [],
            sortingSuperTypes: [],
        // 二级菜单数据
        types: [],
            manageSubTypes: [],
            defaultSites: [],
            sites: [],
            allTypes: [],
            allSites: [],
            moreDialogVisible: false,
            moreDialogTitle: "",
            moreDialogSites: [],
            moreDialogTags: [],
            tagSiteMap: {},
			settingDialogVisible: false,
        //用于判定第几个呈激活状态
		currentSuperType: 1,
            sortingSuperTypeVisible: false,
            typeSites: {},
            finalSites: {},
        // 控制三级菜单的显隐性，true为显示，false则反之
        manageVisible: false,
        // 控制收藏的显隐性，true为显示，false则反之
        dialogTableVisible:false,
        //用于存放收藏list数据
        collectionData:[],
        manageType: {defaultSites:[], customSites:[]}
        };
    },
    methods: {
        init() {
            let today = new Date();
            let dateString = today.toLocaleDateString() + 'v1';

            let lastDay = localStorage.getItem('lastVisitDate') || '';

            if (dateString!==lastDay) {
                localStorage.setItem('lastVisitDate', dateString)
                localStorage.removeItem("typeSites");
            }

            this.typeSites = JSON.parse(localStorage.getItem("typeSites") || '{}')

            this.isLoading = true;
            request({
                url: "api/nav/type?type=1",
                method: "get"
            }).then((r) => {
                this.superTypes =r
                // 获取一级菜单成功后，执行获取一级菜单中第一的二级菜单数据用于初始展示数据
                this.loadSuperType(this.superTypes[0].id)
                // this.stDict = r.superTypeDict;
                // this.superTypes = this.refreshSortedSuperTypes(this.stDict)
                // this.allTypes = r.types;
                // this.allSites = r.sites;
                // 控制懒加载，未完成时显示加载样式
                this.isLoading = false;
                // this.loadSuperType(this.superTypes[0].id);
            }).catch(error => {
                console.log(error);
            });
        },
        // 切换一级菜单时进行触发，获取二级数据
        loadSuperType(id =1) {
            this.currentSuperType = id;
            this.types = [];
            request({
                url: "api/nav/type?type=2&firstId=" + id,
                method: "get"
            }).then((r) => {
                this.types = r
            }).catch(error => {
                console.log(error);
            });
            // 强制刷新页面
            // this.$forceUpdate();
        },
        handleCloseAll() {
            this.$emit('close')
            this.$emit('close-all')
        },
        onManageSave(customs) {
            this.manageType.customSites = customs
            // cs.saveUserCustom(customs, this.manageType.id)
            this.manageType.processType(this.manageType)
        },
        // 点击二级菜单时触发。弹出三级菜单模态框，并传值
        handleClick(type) {
            this.manageType = type
            this.manageVisible = true
        },
        // 点击收藏时触发弹出收藏模态框
        collect(){
            if(this.global.account == null) {
                this.$message({
                message: '请先登录',
                type: 'warning'
                });
                // this.$router.replace('/')
                eventBus.$emit('show-login', '');
            }else{
                this.isLoading1=true
                // 改变dialogTableVisible的值，时收藏模态框显示
                this.dialogTableVisible = true;
                request({
                    url: "/api/nav/collectList",
                    method: "post",
                    data: {"token" : localStorage.getItem("token")}
                }).then((r) => {
                    this.isLoading1=false
                    this.collectionData=r
                }).catch(error => {
                    console.log(error);
                });
            }
        },
        // 删除收藏
        deleteCollect(site){

            // let userSite1={
            //     name:site.name,
            //     url:site.url,
            //     description:site.description,
            //     id:site.id
            // }
            request({
                url: "/api/nav/deleteCollect?id="+site.id,
                method: "get",
                data: {}
            }).then((r) => {
                this.$message({
                    message: '删除成功',
                    type: 'success' //绿色弹窗
                });
                this.collect()
                // this.acquireSites(this.tag)
            }).catch(error => {
                console.log(error);
            });
        },
        showMore(type) {
            this.moreDialogVisible = true;
            this.moreDialogTitle = type.name;
            this.moreDialogSites = this.finalSites[type.id]
            this.moreDialogTags = []
            this.tagSiteMap = {}

            for (const key in this.moreDialogSites) {
                const site = this.moreDialogSites[key];
                site.tagList = []
                if (site.tag) {
                    // split tag and trim them, save as tagList
                    site.tagList = site.tag.split(',').map(tag => tag.trim())

                    //remove duplicate tags
                    site.tagList = [...new Set(site.tagList)]

                    //for each tag add them into moreDialogTags
                    for (const tag of site.tagList) {
                        if (this.moreDialogTags.indexOf(tag) === -1) {
                            this.moreDialogTags.push(tag)
                        }
                    }
                }
            }

            //foreach tag
            for (const tag of this.moreDialogTags) {
                this.tagSiteMap[tag] = []
                //foreach site
                for (const key in this.moreDialogSites) {
                    const site = this.moreDialogSites[key];
                    if (site.tagList.indexOf(tag) !== -1) {
                        this.tagSiteMap[tag].push(site)
                    }
                }
            }
        },
        refreshSortedSuperTypes(dict) {
            function getDictList(dict) {
                return Object.entries(dict).map(([id, value]) => ({ id, value }));
            }

            function checkValid(sorted, dict) {
                if (sorted.length !== Object.keys(dict).length) return false;
                return sorted.every(id => dict.hasOwnProperty(id));
            }

            let list = getDictList(dict);
            let sorted = cs.loadUserCustom(99999);

            if (sorted.length === 0) return list;
            if (!checkValid(sorted, dict)) {
                cs.clear(99999);
                return list;
            }

            return sorted.map(id => ({ id, value: dict[id] }));
        },
        closeSortingSuperType() {
            this.sortingSuperTypeVisible = false;
        },
        showSettingSubType(id) {
            this.manageSubTypes = this.loadSortedTypes2(id) || [];

            if (this.manageSubTypes.length === 0) {
                this.manageSubTypes = this.allTypes.filter(type => type.superType == id);
            }

            this.settingDialogVisible = true;
        },
        showSortingSuperType() {
            this.sortingSuperTypeVisible = true
            this.sortingSuperTypes = []
            console.log(this.superTypes)
            for (const superTypesKey in this.superTypes) {
                this.sortingSuperTypes.push(this.superTypes[superTypesKey])
            }
        },
        handleSuperTypeSave() {
            this.sortingSuperTypeVisible = false
            let sorted = []
            for (let i = 0; i < this.sortingSuperTypes.length; i++) {
                const item = this.sortingSuperTypes[i]
                sorted.push(item.id)
            }

            console.log(sorted)
            cs.saveUserCustom(sorted, 99999)
            this.superTypes = this.refreshSortedSuperTypes(this.stDict)
        },
        async processType(type) {

        },




        loadSortedTypes2(superType) {
            let r = JSON.parse(localStorage.getItem('type_sort_' + superType))

            if(r == null) {
                return
            }

            let tMap = {}
            let cMap = {}

            let tmpList = []
            for (let i = 0; i < this.types.length; i++) {
                const type = this.types[i];
                tMap[type.id] = type
            }

            tmpList = []
            for (let i = 0; i < r.length; i++) {
                const id = r[i];
                if(!tMap[id]) {
                    return
                }
                tmpList.push(tMap[id])
                cMap[id] = tMap[id]
            }

            for (let i = 0; i < this.types.length; i++) {
                const type = this.types[i];
                if(!cMap[type.id]) {
                    // tmpList.push(type)
                    return
                }
            }

            return tmpList
        },



		loadSortedTypes() {
			let r = JSON.parse(localStorage.getItem('type_sort_' + this.currentSuperType))

			if(r == null) {
				return
			}

			let tMap = {}
			let cMap = {}

			let tmpList = []
			for (let i = 0; i < this.types.length; i++) {
                const type = this.types[i];
				tMap[type.id] = type
			}

			tmpList = []
			for (let i = 0; i < r.length; i++) {
				const id = r[i];
				if(!tMap[id]) {
					return
					continue;
				}
				tmpList.push(tMap[id])
				cMap[id] = tMap[id]
			}

			for (let i = 0; i < this.types.length; i++) {
                const type = this.types[i];
				if(!cMap[type.id]) {
					// tmpList.push(type)
					return
				}
			}

			this.types = tmpList
		},



		saveSortedTypes(r) {
			localStorage.setItem('type_sort_' + this.currentSuperType, JSON.stringify(r))

			this.loadSortedTypes()
		},
		addToCommon(site) {
			this.$bus.$emit('addCommon', site)
		}
    }
}
</script>

<style>
.site-tooltip .popper__arrow {
    border-bottom-color: #93959b !important;
}

.site-tooltip .popper__arrow::after {
    border-bottom-color: #93959b !important;
}

.more-site-dialog .el-dialog {
    margin-top: 20vh !important;
    min-height: 125px;
}

.more-site-dialog .el-dialog__body {
    padding: 10px  20px;
}
.more-site-dialog .el-loading-spinner{
    margin-top: 5px;
}

/* .more-site-dialog .el-dialog__title {
    color: #0070c0;
    font-size: 19px;
    font-weight: bolder;
} */

/* .more-site-dialog .el-divider--horizontal {
    height: 2px;
} */
.Mdivider .el-divider--horizontal {
    margin:0 0 5px 0;
}
</style>

<style scoped>


.website { width: 913px; background: #fff; overflow: hidden; border:#e8e8e8 1px solid; margin-top:20px}
.website h3 { height: 54px; line-height: 54px; color: #666; font-size: 18px; padding: 0 20px; border-bottom: #e8e8e8 1px solid;}
.website h3 a { float: right; color: #14aab9; font-size: 16px;}
.website dl { width: 873px; height: 38px; padding: 0 20px;overflow: hidden;}
.website dl dt { width:65px; float: left ; line-height: 30px; color:#666; /*font-weight: bold;*/ padding-right: 15px;}
.website dl dt a { color: #0070c0;}
.website dl dd { width:793px; float: right ; line-height: 30px;}
.website dl dd li a { width: 105px; display: inline-block; float: left; color: #000000; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;}
.website dl dd span.last-span a { float: right; width: 35px; text-align: right; color: #0070c0;padding-right: 20px;}

.el-tabs {
	padding: 0 20px;
}

.more-dialog {
	line-height: 32px;
    margin-left: 30px;
}
.more-dialog li {
	display: inline-block;
    padding: 0 10px;
    width: 135px;
    white-space: nowrap;
}
.more-dialog li a {
	width: 120px;
	text-overflow: ellipsis;
	overflow: hidden;
	display: inline-flex;
}

ul.tab {
  padding: 8px 20px;
  height: 55px;
  background: #f0f3f3;
}

ul.tab li div {
    border-radius: 4px;
    border: transparent;
    transition: all .3s;
    background-color: transparent;
}
ul.tab li div.on {
    border: 1px solid rgb(0, 112, 192);
    color: rgb(0, 112, 192);
    background-color: #edeff37a;
}
ul.tab li {
  float: left;
  text-align: center;
  width: 11.1%;
  font-weight: bold;
  line-height: 30px;
    height: 30px;
}

.type-item {
    padding: 4px;
    height: 28px;
    display: inline;
    align-items: center;
    width: 16.66666667%;
}

.type-item > span {
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.gray {
    background: #fcfcfc;
    padding: 8px 20px;
}
.tooltip{
    float: left;
    width: 11.1%;
    align-self: center;
    color: #000;

}
.tooltip>div{
    height: 38px;
    line-height: 38px;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/MoreSites.vue